<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Client {{ data }} requires a Purchase Order.</p>
    <div style="text-align: center;">
      <el-input
        v-model="purchaseOrderNumber"
        type="text"
        style="max-width: 300px;"
        placeholder="Purchase Order Number"
        maxlength="25"
        show-word-limit
      />
      <div>
        <button type="button" @click="addPurchaseOrder" style="margin-right: 10px;" class="btn btn-fill btn-info inline-block">Add PO Number</button>
        <p-button wide class="inline-block" @click.native="closeModal">Skip</p-button>
      </div>
    </div>
  </div>
</template>

<script>
import {notifyWarning} from '@/utilities/utils'
import Constants from '@/utilities/constants'

export default {
  props: ['data'],
  data() {
    return {
      purchaseOrderNumber: null,
      purchaseOrderSent: false
    }
  },
  methods: {
    addPurchaseOrder() {
      if (this.purchaseOrderNumber && Constants.REGEX.PO_REGEX.test(this.purchaseOrderNumber)) {
        this.$eventHub.$emit('jobClientOrPoChecksComplete', this.purchaseOrderNumber)
        this.purchaseOrderSent = true
        this.$emit('close')
        return
      }
      notifyWarning(this, 'Please enter a valid Purchase Order Number. It must contain only numbers, letters, hyphens, periods, forward slashes, underscores, and spaces. If this warning persists, type the P.O. Number manually. Don\'t paste it.')
    },
    closeModal() {
      this.$emit('close')
    }
  },
  destroyed() {
    if (!this.purchaseOrderSent) {
      this.$eventHub.$emit('jobClientOrPoChecksComplete')
    }
  }
}
</script>
